/** @format */

import { Vue, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';

@Component
export default class GoBackWithCloseTab extends Vue {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  path = '';
  // 返回
  goBack(path?: string) {
    const backPath = path || this.path;

    if (backPath) {
      // 清除当前tab页签
      this.closeCurrentTab({ activePage: window.activePage, nextRoute: backPath });
    } else {
      this.$router.go(-1);
    }
  }
}
